/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

export { App, PortletStoreApi, poeStateChanged } from './App';

const originalConsoleLog = console.log;

console.log = function (...args: any[]) {
  try {
    originalConsoleLog.apply(console, args);
  } catch (e) {
    let errorArgs = ['error when calling console log', (e as any)?.message];
    if (args && args.length > 0 && typeof args[0] === 'string') {
      errorArgs = [...errorArgs, 'message: ' + args[0]];
    }
    originalConsoleLog.apply(console, errorArgs);
  }
};
